import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api.js';

const URL = `${process.env.REACT_APP_API_URL}/api/articoliDemo2`;

export const fetchArticles = createAsyncThunk(
  'articles/fetchArticles',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get(URL);
      return res.data.articoli || [];
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'error loading articles');
    }
  }
);


export const addArticle = createAsyncThunk(
  'articles/addArticle',
  async (article, { rejectWithValue }) => {
    try {
      const res = await api.post(URL, article);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'error adding article');
    }
  }
);


export const editArticle = createAsyncThunk(
  'articles/editArticle',
  async (article, { rejectWithValue }) => {
    try {
      const { id, nome, descrizione, categoria } = article;
      const res = await api.put(`${URL}/${id}`, { nome, descrizione, categoria });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'error editing article');
    }
  }
);


export const deleteArticle = createAsyncThunk(
  'articles/deleteArticle',
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`${URL}/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'error deleting article');
    }
  }
);


const articlesSlice = createSlice({
  name: 'articles',
  initialState: {
    list: [],
    currentPage: 1,
    isLoading: false,
    error: null,
  },
  reducers: {
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchArticles.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchArticles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchArticles.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // add
      .addCase(addArticle.fulfilled, (state, action) => {
        state.list.push(action.payload);
      })
      .addCase(addArticle.rejected, (state, action) => {
        state.error = action.payload;
      })

      // edit
      .addCase(editArticle.fulfilled, (state, action) => {
        const updated = action.payload;

        if (!updated || typeof updated !== 'object' || !updated.id) {
          console.warn("editArticle returned invalid data:", updated);
          return;
        }

        const updatedId = String(updated.id);
        const index = state.list.findIndex(item => String(item.id) === updatedId);

        if (index !== -1) {
          state.list[index] = { ...state.list[index], ...updated };
        } else {
          console.warn(
            `Could not find article with id ${updatedId} in list. ` +
            `Current ids: ${state.list.map(i => i.id).join(', ')}`
          );
        }
      })

      .addCase(editArticle.rejected, (state, action) => {
        state.error = action.payload || 'Error updating article';

      })

      // delete
      .addCase(deleteArticle.fulfilled, (state, action) => {
        state.list = state.list.filter((item) => item.id !== action.payload);
      })
      .addCase(deleteArticle.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, clearError } = articlesSlice.actions;
export default articlesSlice.reducer;
